import { render, staticRenderFns } from "./ContestDetails.vue?vue&type=template&id=33bc08fa&scoped=true"
import script from "./ContestDetails.vue?vue&type=script&lang=ts"
export * from "./ContestDetails.vue?vue&type=script&lang=ts"
import style0 from "./ContestDetails.vue?vue&type=style&index=0&id=33bc08fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bc08fa",
  null
  
)

export default component.exports